export default "__VITE_PUBLIC_ASSET__4e4b6e49__"